<h2>{{summary.title}}</h2>
<span>By {{summary.author}}</span>&nbsp;&nbsp;<span>Published On {{summary.published}}</span>
